import { Box } from "ui/box";
import { Chip } from "ui/chip";
import { Typography } from "ui/typography";

import type { FontFamilyPreview as FontFamilyPreviewData } from "containers/admin/clients/client/theme-configuration-page/brand-identity/fonts-tab/fonts-tab.types";

import {
  FAMILY_HEADER_SX,
  FAMILY_SX,
  FontSample,
  WEIGHT_SX,
  WEIGHTS_SX,
} from "containers/admin/clients/client/theme-configuration-page/brand-identity/fonts-tab/fonts-tab.styles";
import {
  FONT_SAMPLE_TEXT,
  FONT_SOURCE_LABELS,
  FONT_WEIGHT_NAMES,
} from "containers/admin/clients/client/theme-configuration-page/brand-identity/fonts-tab/fonts-tab.constants";

type FontFamilyPreviewProps = {
  font: FontFamilyPreviewData;
};

export const FontFamilyPreview = ({ font }: FontFamilyPreviewProps) => (
  <Box component="section" aria-label={`${font.name} font family`} sx={FAMILY_SX}>
    <Box sx={FAMILY_HEADER_SX}>
      <Typography variant="subtitle2" component="h4">
        {font.name} font family
      </Typography>
      <Chip size="small" variant="outlined" color="secondary" label={FONT_SOURCE_LABELS[font.source]} />
    </Box>
    <Box sx={WEIGHTS_SX}>
      {font.weights.map((weight) => (
        <Box key={weight} sx={WEIGHT_SX}>
          <Typography variant="body2" component="p">
            {weight} {FONT_WEIGHT_NAMES[weight]} Font Weight
          </Typography>
          <FontSample sampleFontFamily={font.cssFontFamily} sampleFontWeight={weight}>
            {FONT_SAMPLE_TEXT}
          </FontSample>
        </Box>
      ))}
    </Box>
  </Box>
);
